import React, { useEffect, useState } from 'react';
import { useNotifications } from './Notifications';
import { supabase } from '../lib/supabaseClient';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [stage, setStage] = useState('init');
  const { push } = useNotifications ? useNotifications() : { push: () => {} };

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setStage('recover');
      if (event === 'SIGNED_IN') setStage('ready');
    });
    return () => { sub?.subscription?.unsubscribe?.(); };
  }, []);

  const update = async (e) => {
    e?.preventDefault?.();
    if (!password || password !== confirm) {
      push('Las contraseñas no coinciden', { type: 'error' });
      return;
    }
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      push('Contraseña actualizada', { type: 'success' });
      window.location.assign('/login');
    } catch (err) {
      push(err?.message || 'No se pudo actualizar la contraseña', { type: 'error' });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-950 p-4">
      <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-200 dark:border-gray-800 p-6 space-y-5">
        <div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Restablecer contraseña</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">Ingresa tu nueva contraseña.</p>
        </div>
        <form className="space-y-4" onSubmit={update}>
          <div>
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1">Nueva contraseña</label>
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1">Confirmar contraseña</label>
            <input type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100" />
          </div>
          <button type="submit" className="w-full inline-flex justify-center items-center px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition">Actualizar</button>
        </form>
      </div>
    </div>
  );
}


